import { useMemo } from 'react';
import { useVaultStatsWithDepositors } from './useVaultStatsWithDepositors';

type VaultTab = 'verified' | 'community' | 'my_positions';

export const useVaultManagerOptions = (activeTab: VaultTab) => {
	const vaultStatsWithDepositors = useVaultStatsWithDepositors();

	return useMemo(() => {
		const uniqueVaultManagers = vaultStatsWithDepositors
			.filter(({ vaultStat, depositor }) => {
				const isActive =
					depositor?.vaultDepositor.vaultShares.gtn(0) ||
					!vaultStat.uiVaultConfig.isDeprecating;

				const passesTabFilter = (() => {
					if (activeTab === 'verified') {
						return vaultStat.uiVaultConfig.isVerified;
					}

					if (activeTab === 'community') {
						return !vaultStat.uiVaultConfig.isVerified;
					}

					return depositor !== null;
				})();

				return isActive && passesTabFilter;
			})
			.map(({ vaultStat }) => vaultStat.uiVaultConfig.vaultManager)
			.filter(
				(manager, index, self) =>
					self.findIndex((m) => m.name === manager.name) === index
			);

		return [
			{ value: 'All', label: 'All' },
			...uniqueVaultManagers.map((manager) => ({
				value: manager.name,
				label: manager.name,
				icon: <img src={manager.imgSrc} className="h-[18px] w-[18px]" />,
			})),
		];
	}, [activeTab, vaultStatsWithDepositors]);
};
